/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {getUserByToken, login} from '../core/_requests'
import {useAuth} from '../core/Auth'
import {useDataLayerValue} from '../../../../DataLayer'
import toaster from '../../../../utils/toaster'

const loginSchema = Yup.object().shape({
  emailUserName: Yup.string().required('Email or Username is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  emailUserName: '',
  password: '',
}

export function Login() {
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()
  const [, dispatch] = useDataLayerValue()
  const [showPassword, setShowPassword] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState)
  }

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data: auth} = await login(values.emailUserName, values.password)
        if (auth.isAuthenticated === false) {
          setLoading(false)
          toaster('error', auth.message)
          setStatus(auth.message)
        } else {
          if ([22.1, 22.2].some((number) => JSON.parse(auth?.policies)?.includes(number))) {
            dispatch({
              type: 'SET_POLICIES',
              policies: JSON.parse(auth?.policies),
            })
            saveAuth(auth)
            const {data: user} = await getUserByToken()
            toaster('success', 'Login successful')
            setCurrentUser(user)
          } else {
            toaster('error', 'Unauthorized')
          }
        }
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('The login detail is incorrect')
      } finally {
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      {/* <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-2'>Sign In</h1>

        <div className='text-gray-800 fw-semibold fs-6'>Please sign in to continue</div>
      </div> */}
      {/* begin::Heading */}

      {/* begin::Separator */}

      {/* end::Separator */}

      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
        <></>
        // <div className='mb-10 bg-light-info p-8 rounded'>
        //   <div className='text-info'>
        //     Use account <strong>admin@demo.com</strong> and password <strong>demo</strong> to
        //     continue.
        //   </div>
        // </div>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>Email or Username</label>
        <input
          placeholder='Email or Username'
          {...formik.getFieldProps('emailUserName')}
          className={clsx(
            'form-control',
            {'is-invalid': formik.touched.emailUserName && formik.errors.emailUserName},
            {
              'is-valid': formik.touched.emailUserName && !formik.errors.emailUserName,
            }
          )}
          type='text'
          name='emailUserName'
          autoComplete='off'
          value={formik.values.emailUserName}
          onChange={(e) => {
            formik.setFieldValue('emailUserName', e.target.value)
          }}
        />
        {formik.touched.emailUserName && formik.errors.emailUserName && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.emailUserName}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
        <div className='position-relative'>
          <input
            placeholder='Password'
            type={showPassword ? 'text' : 'password'}
            autoComplete='off'
            {...formik.getFieldProps('password')}
            className={clsx(
              'form-control pr-10', // Add padding to accommodate the icon
              {
                'is-invalid': formik.touched.password && formik.errors.password,
              },
              {
                'is-valid': formik.touched.password && !formik.errors.password,
              }
            )}
          />
          <i
            className={clsx('bi', showPassword ? 'bi-eye-slash' : 'bi-eye', 'position-absolute', {
              'd-none': formik.values.password === '',
            })}
            onClick={togglePasswordVisibility}
            style={{
              right: '35px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              fontSize: '1.25rem',
              color: '#555',
            }}
          ></i>
        </div>
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}
      {/* begin::Action */}
      <div className='d-grid mb-6 mt-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Continue</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}

      {/* <div className='text-gray-900 text-center fw-semibold fs-6'>
        Not a Member yet?{' '}
        <Link to='/auth/registration' className='link-primary fw-bolder'>
          Sign up
        </Link>
      </div> */}
    </form>
  )
}
